import React from 'react';
import { motion } from 'framer-motion';
import Button from '../common/Button';
import PhoneMockups from './PhoneMockups';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../../common/SafeIcon';

const { FiShield } = FiIcons;
const { FaApple, FaGooglePlay } = FaIcons;

const APP_STORE_URL = "https://apps.apple.com/us/app/nisaa/id6772802488";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=uk.co.sussexendocrineclinic.nisaa";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen overflow-hidden flex items-center bg-paper pt-20 lg:pt-0">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-aubergine/[0.02] -skew-x-12 transform origin-top-right hidden lg:block" />
      <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-rose/5 rounded-full blur-[100px]" />
      <div className="absolute bottom-[10%] right-[10%] w-96 h-96 bg-aubergine/5 rounded-full blur-[120px]" />
      
      <div className="w-full max-w-[1120px] mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] items-center gap-12 lg:gap-16">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <motion.div 
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose/10 text-rose font-bold text-xs uppercase tracking-wider mb-6"
            >
              <SafeIcon icon={FiShield} className="w-3.5 h-3.5" />
              Privacy-First Health Companion
            </motion.div>
            
            <h1 className="text-[clamp(2.8rem,5vw,4.8rem)] leading-[1.1] tracking-tight">
              Body, Worship <br />
              <span className="text-rose">&</span> Pregnancy.
            </h1>
            
            <p className="text-[1.1rem] lg:text-[1.25rem] text-muted max-w-[580px] mt-6 leading-relaxed">
              A calm, private space for Muslim women. Track your cycle, calculate prayer times, record fasts, and follow your pregnancy journey without ads or data tracking.
            </p>

            <div className="flex flex-wrap gap-4 mt-10">
              <a 
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-aubergine text-white px-6 py-3 rounded-2xl hover:bg-aubergine-light transition-all shadow-btn group"
              >
                <SafeIcon icon={FaApple} className="w-6 h-6" />
                <div className="text-left">
                  <p className="text-[10px] uppercase font-bold leading-none opacity-60">Download on the</p>
                  <p className="text-lg font-bold leading-tight">App Store</p>
                </div>
              </a>
              <a 
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-white border border-line text-aubergine px-6 py-3 rounded-2xl hover:bg-paper transition-all shadow-soft group"
              >
                <SafeIcon icon={FaGooglePlay} className="w-5 h-5" />
                <div className="text-left">
                  <p className="text-[10px] uppercase font-bold leading-none opacity-60">Get it on</p>
                  <p className="text-lg font-bold leading-tight">Google Play</p>
                </div>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 mt-12 pt-8 border-t border-line/50">
              <div className="flex -space-x-3">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-line overflow-hidden">
                    <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" />
                  </div>
                ))}
              </div>
              <p className="text-sm text-muted font-medium">
                <span className="text-aubergine font-bold">Trusted</span> by women globally for private health tracking.
              </p>
            </div>
          </motion.div>

          <div className="relative">
            <PhoneMockups />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;